<template>
   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="icon-share" x="0px" y="0px" viewBox="0 0 30.62 33.32" style="enable-background:new 0 0 30.62 33.32;" xml:space="preserve">
        <path class="st0" d="M30.25,0.22c-0.32-0.25-0.75-0.29-1.1-0.1L0.52,15.64c-0.36,0.19-0.56,0.58-0.52,0.99  c0.04,0.4,0.33,0.74,0.72,0.85l12.75,3.69l6.39,11.63c0.18,0.32,0.51,0.52,0.88,0.52c0.04,0,0.08,0,0.11-0.01  c0.4-0.05,0.74-0.33,0.85-0.72l8.88-31.32C30.69,0.89,30.56,0.47,30.25,0.22z M3.62,16.24l22.13-12L13.84,19.11l0.17,0.14  L3.62,16.24z M20.44,29.71l-5.21-9.48l0.17,0.14L27.31,5.49L20.44,29.71z"/>
    </svg>
</template>

<script>
export default {
    name: "icon-share",
}
</script>
